import { SpanControl } from "@/Common/Components/SpanControl";
import { Patient } from "@/Common/Models/Patient/Patient";
import { Person } from "@/Common/Models/Person/Person";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { ApssClient } from "@/Patient/Api/Apss/ApssClient";
import { PatientFormAPSS } from "@/Patient/Api/Dto/Responses/PatientFormAPSS";
import { ApssInbox } from "@/Portfolio/Components/APSSInbox";

import ApssFormSectionStyle from "./ApssFormSection.module.css";

interface ApssFormSectionProps {
    patientAPSSForms: PatientFormAPSS[];
    patientModel: Patient;
    isReadOnly?: boolean;
}

function ApssFormSection(props: ApssFormSectionProps): JSX.Element {
    const reloadAPSSForm = (formId: number, historicalId: string): void => {
        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.LoadApssFormInfo,
            { formId, historicalId }
        );
    };

    const onAPSSFormClick = (docId: string, historicalId: string): void => {
        ApssClient.openForm(docId, historicalId);
    };

    const openAttachPopup = (requeteId: string, DocumentCode: string): void => {
        const patientperson = Person.FromPatient(props.patientModel);

        sessionStore.dispatchMain(LocalOperations.MainComponentViewOperations.DisplayAttachmentPopup, {
            AttachmentPopupResponseCallback: (attachments: ExportableFile[]) => {
                const persistentRequeteId = requeteId.toString(); // Data sometimes get lost in the callback?? Weird... Cloning solves the issue
                const persistentDocumentCode = DocumentCode.toString();

                patientStore.ActionsMedicalNote.AttachAPSSFiles(
                    persistentRequeteId,
                    persistentDocumentCode,
                    attachments,
                    props.patientModel.IndividualResponse.Contact_id
                );
            },
            AttachmentPopupPatientPerson: patientperson,
            AttachmentPopupMaxFiles: 5
        });
    };

    return (
        <>
            {props.patientAPSSForms.map((form: PatientFormAPSS) => {
                const cachedPrerequis = PatientFormAPSS.GetCachedPrerequis(form.LstPrerequis);
                // this is not pretty, but it's the only info we got from the CRDS list that make
                // us differentiate a conseil num. form from the other one......
                const attachFormCode = form.FormName === "Conseil Numérique" ? "demandeurDocument" : "rprt_AUTRES";

                return (
                    <div
                        key={form.Id}
                        className={(!props.isReadOnly && cacheStore.ClinicSettings.EnableQuickDocumentSigning) ? ApssFormSectionStyle.pdfFormViewControlFormatted : ApssFormSectionStyle.pdfFormViewControl}
                    >
                        <div className="flex-display flex-align-items-center">
                            {!props.isReadOnly && (
                                <div
                                    className={"pointer a text-center " + ApssFormSectionStyle.pointerContainer}
                                    onClick={() => reloadAPSSForm(form.APSSId, form.HistoricalId)}
                                >
                                    {!form.IsLoading && (
                                        <div
                                            className={ApssFormSectionStyle.refreshBackground}
                                        />
                                    )}
                                </div>
                            )}
                            <div className={`${props.isReadOnly ? ApssFormSectionStyle.formNameReadOnly : ApssFormSectionStyle.formName} ${ApssFormSectionStyle.bContainer}`}>
                                <div className="flex-display flex-start">
                                    <div>
                                        <a
                                            className="text-bold"
                                            onClick={() => onAPSSFormClick(form.APSSId.toString(), form.HistoricalId)}
                                        >
                                            {form.FormName}
                                        </a>
                                    </div>
                                    <div className="push-left-5 flex-shrink-0">
                                        <span style={PatientFormAPSS.GetStatusStyle(form)}>
                                            {PatientFormAPSS.GetStatus(form)}
                                        </span>
                                    </div>
                                </div>
                                {!form.APssFormDetails && cachedPrerequis && (
                                    <div className="marginleft20">
                                        {cachedPrerequis.map(prerequis => {
                                            if (prerequis.IsMissing) {
                                                return (
                                                    <div key={form.APSSId + "_prer_"} className="flex-container flex-start">
                                                        <div>
                                                            <a onClick={() => openAttachPopup(form.APSSId.toString(), prerequis.Code)}>
                                                                {cacheStore.GetString("AttachLabel")}
                                                            </a>
                                                        </div>
                                                        <div className="push-left-8">
                                                            <SpanControl
                                                                IsRed={true}
                                                                text={prerequis.Name}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                return (
                                                    <div
                                                        key={form.APSSId + "_prer_"}
                                                        onClick={e => ApssInbox.openAPSSDocument(form.APSSId.toString(), prerequis.Code, e)}
                                                    >
                                                        <a>
                                                            <SpanControl
                                                                className="link-label"
                                                                text={prerequis.Name}
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            }
                                        })}
                                        {!props.isReadOnly && (
                                            <div key={form.APSSId + "_prer_" + "autreCached"} className="flex-container flex-start">
                                                <div>
                                                    <a onClick={() => openAttachPopup(form.APSSId.toString(), attachFormCode)}>
                                                        {cacheStore.GetString("AttachLabel")}
                                                    </a>
                                                </div>
                                                <div className="push-left-8">
                                                    <div onClick={e => ApssInbox.openAPSSDocument(form.APSSId.toString(), attachFormCode, e)}>
                                                        <a>
                                                            <SpanControl
                                                                className="link-label"
                                                                text="Autre_Rapport"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {form.APssFormDetails && (
                                    <div className="marginleft20">
                                        {form.APssFormDetails.Prerequis.map(prerequis => {
                                            const item = form.APssFormDetails;

                                            if (prerequis.IsMissing) {
                                                return (
                                                    <div key={item.Model.ReqReg_Id + "_prer_"} className="flex-container flex-start">
                                                        <div>
                                                            <a onClick={() => openAttachPopup(item.Model.ReqReg_Id, prerequis.Code)}>
                                                                {cacheStore.GetString("AttachLabel")}
                                                            </a>
                                                        </div>
                                                        <div className="push-left-8">
                                                            <SpanControl
                                                                IsRed={true}
                                                                IsBold={item.IsBold()}
                                                                text={prerequis.Name}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                return (
                                                    <div
                                                        key={item.Model.ReqReg_Id + "_prer_"}
                                                        onClick={e => ApssInbox.openAPSSDocument(item.Model.ReqReg_Id, prerequis.Code, e)}
                                                    >
                                                        <a>
                                                            <SpanControl
                                                                className="link-label"
                                                                IsGreen={item.IsGreen()}
                                                                IsBold={item.IsBold()}
                                                                text={prerequis.Name}
                                                            />
                                                        </a>
                                                    </div>
                                                );
                                            }
                                        })}
                                        {!props.isReadOnly && (
                                            <div
                                                key={form.APssFormDetails.Model.ReqReg_Id + "_prer_" + "autre"}
                                                className="flex-container flex-start"
                                            >
                                                <div>
                                                    <a onClick={() => openAttachPopup(form.APssFormDetails.Model.ReqReg_Id, attachFormCode)}>
                                                        {cacheStore.GetString("AttachLabel")}
                                                    </a>
                                                </div>
                                                <div className="push-left-8">
                                                    <div onClick={e => ApssInbox.openAPSSDocument(form.APssFormDetails.Model.ReqReg_Id, attachFormCode, e)}>
                                                        <a>
                                                            <SpanControl
                                                                IsGreen={form.APssFormDetails.IsGreen()}
                                                                IsBold={form.APssFormDetails.IsBold()}
                                                                text="Autre_Rapport"
                                                            />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        {!props.isReadOnly && (
                            <div>
                                <button
                                    className="button control push-right-15"
                                    onClick={() =>
                                        sessionStore.getAPSSToken().then(() => ApssClient.printForm(form.APSSId, form.HistoricalId))
                                    }
                                >
                                    <i className="fi-print col-lg-icon" />
                                </button>
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
}

export { ApssFormSection };
